import React, { useEffect, useState } from "react";
import GetSuggestion from "../api/GetSuggestion";
import formatDate from "../../../utils/FormatDate";

function Suggestions() {
  // filter Suggestions  apply filtration
  const [filterSuggestions, setFilterSuggestions] = useState([]);
  const [filterDate, setFilterDate] = useState("");

  // use Effect
  useEffect(() => {
    const getSuggestionData = async () => {
      setFilterSuggestions(await GetSuggestion());
    };
    getSuggestionData();
  }, []);

  // for Change Date
  const handlerForm = (e) => {
    e.preventDefault();
    if (filterDate) {
      const filtered = filterSuggestions.filter(
        (suggestion) => formatDate(suggestion.date) === formatDate(filterDate)
      );
      setFilterSuggestions(filtered);
    }
  };
  return (
    <>
      <section className="body-font text-gray-600">
        <div className="container mx-auto py-8">
          <div className="mb-12 flex flex-col md:flex-row-reverse justify-between items-center md:border-b pb-2">
            <h2 className="text-right text-2xl font-bold p-4 mb-4 md:mb-0">الإقتراحات</h2>
            <form
              onSubmit={handlerForm}
              className="flex flex-col p-4 items-center md:flex-row-reverse md:items-center"
            >
              <div className="mb-2 mx-4 flex flex-row-reverse items-center">
                <label>الإقتراحات حسب التاريخ</label>
                <input
                  type="date"
                  className="py-2 px-6 bg-white"
                  dir="trl"
                  value={filterDate}
                  onChange={(e) => {
                    setFilterDate(e.target.value);
                  }}
                />
              </div>
              <div className="mb-2  flex flex-row-reverse items-center">
                <button type="submit" className="py-2 px-4 bg-blue-500 rounded text-mld text-white">
                  بحث
                </button>
              </div>
            </form>
          </div>
          <div className="-m-4 flex flex-wrap flex-row-reverse">
            <div className="container mx-auto p-4">
              <div className="overflow-x-auto">
                <table className="min-w-full overflow-hidden rounded-lg bg-white">
                  <thead className="bg-gray-100">
                    <tr className="text-sm uppercase leading-normal text-gray-600">
                      <th className="px-4 py-3 text-right">تفاصيل الإقتراح</th>
                      <th className="px-4 py-3 text-right">عنوان الإقتراح</th>
                      <th className="px-4 py-3 text-right">تاريخ الإقتراح</th>
                      <th className="px-4 py-3 text-right">صاحب الإقتراح</th>
                    </tr>
                  </thead>
                  <tbody className="text-sm font-light text-gray-600">
                    {filterSuggestions.length !== 0 ? (
                      filterSuggestions.map((suggestion) => {
                        return (
                          <tr
                            key={suggestion.id}
                            className="border-b border-gray-200 hover:bg-gray-100"
                          >
                            <td className="px-4 py-4 text-right">{suggestion.content}</td>
                            <td className="px-4 py-4 text-right">{suggestion.title}</td>
                            <td className="px-4 py-4 text-right">{formatDate(suggestion.date)}</td>
                            <td className="px-4 py-4 text-right">{suggestion.userName}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="border-b border-gray-200 hover:bg-gray-100">
                        <td className="px-4 py-4 text-right"></td>
                        <td className="px-4 py-4 text-right"></td>
                        <td className="px-4 py-4 text-right"></td>
                        <td className="px-4 py-4 text-right font-bold text-lg">لا يوجد إقتراحات</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Suggestions;
